import * as React from 'react';

import { NavLink } from 'react-router-dom';
import { USERS, INVITED_USER } from '../../../../constants/routes';
import classnames from 'classnames';

interface UserTabProps {
    toggleCurrentUsers: boolean;
    setToggleCurrentUsers: (toggle: boolean) => void;
}

const UserTab: React.SFC<UserTabProps> = (props: UserTabProps) => {
    return (
        <div className="project-add--tabs">
            <li
                className={classnames(`tab-menu`, {
                    active: props.toggleCurrentUsers
                })}
                onClick={() => props.setToggleCurrentUsers(true)}
            >
                <span className="tab-menu--title">Users</span>
            </li>{' '}
            <li
                className={classnames(`tab-menu`, {
                    active: !props.toggleCurrentUsers
                })}
                onClick={() => props.setToggleCurrentUsers(false)}
            >
                <span className="tab-menu--title">Invited users</span>
            </li>
        </div>
    );
};

export default UserTab;
